<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">
                <div id="search-box-index">
                    <div class="ebc-tabs no-scrollbar">
                        <a href="/jinrong/mt4/" class="ebc-tab-line-item"> MT4 </a>
                        <a href="/jinrong/mt5/" class="ebc-tab-line-item"> MT5 </a>
                        <a href="/jinrong/trading-central/" class="ebc-tab-line-item">
                            Trading Central
                        </a>
                        <a href="javascript:;" class="ebc-tab-line-item ebc-tab-line-item-selected">
                            Trading View
                        </a>
                    </div>
                </div>
                <h1 class="">Trading View</h1>
                <div class="forex-title-intro">
                    TradingView
                    是一个基于云端的社交图表与分析平台，广泛用于全球交易者和策略分享者之间的协作。<br />
                    它支持数百种图表类型和指标插件，并允许用户自定义脚本与策略回测。<br />
                    TradingView
                    提供多市场行情（包括外汇、美股等），并通过其社群系统助力用户获取实时观点与热门策略，是新一代交易者首选的可视化分析平台。
                </div>
                <div class="forex-btn-group">
                     <ebc-btn class="ebc-btn">立即获取</ebc-btn>
                </div>
                <section class="section1 mt-50">
                    <h2 class="">TradingView基础教程</h2>
                    <div class="swiper document-list-wrapper1">
                        <swiper ref="swiperBasic" :options="swiperBasicOptions" class="document-list">
                            <swiper-slide v-for="vo in basicList" :id="vo.id">
                                <div class="document-item">
                                    <a :href="vo.url.replace('/zh-cn', '')" class="document-item-img-box">
                                        <img class="document-item-img" :src="vo.thumbnail" :alt="vo.post_title" />
                                    </a>
                                    <div>
                                        <a :href="vo.url.replace('/zh-cn', '')" class="document-item-title">{{
                                            vo.post_title }}</a>
                                        <div class="document-btn-text">
                                            {{ formateTime(vo.published_time) }}
                                        </div>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </section>
                <section class="section2">
                    <h2 class="">TradingView相关问题</h2>
                    <div class="QA-list">
                        <div class="QA-item">
                            <div class="QA-title">
                                1. TradingView 是什么平台？适合用来做什么？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    TradingView
                                    是一个基于浏览器的图表平台，提供丰富的技术分析工具、社区观点和脚本编程环境，适合用于图表分析与策略分享。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                2. 如何在 TradingView 上查找和分析外汇/黄金行情？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    在搜索框中输入如“XAUUSD”或“EURUSD”，可调出实时图表，支持添加指标、绘图、保存策略模板。
                                </p>
                            </div>
                        </div>

                        <div class="QA-item">
                            <div class="QA-title">
                                3. TradingView 有哪些会员等级？免费版是否够用？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    分为 Free、Pro、Pro+、Premium
                                    四级，免费版提供基本功能，若需多图表窗口、自定义脚本或无广告体验可考虑升级。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                4. TradingView 可以绑定真实交易账户吗？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    TradingView支持交易账户连接，用户可直接在图表中执行交易。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">5. TradingView 的 Pine Script 是什么？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    Pine Script 是 TradingView
                                    自研的脚本语言，用户可以使用它编写自定义指标和交易策略，用于图表分析与策略测试。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">
                                6. TradingView 是否支持中文？适合国内用户使用吗？
                            </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    支持完整中文界面与输入，适合全球用户使用。中文用户可通过注册EBC账户进行领取会员，可直接免费体验完整的图标功能。
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import moment from 'moment';
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import { getTradingViewTutorial } from '../../serve/forex.js';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'


export default {
    components: {
        forexMenu,
         Swiper, SwiperSlide
    },
    data() {
        return {
            basicList: [],
            advancedList: [],
            swiperBasicOptions: {
                slidesPerView: 1.1,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
            swiperAdvancedOptions: {
                slidesPerView: 3,
                spaceBetween: 15,
                observer: true,
                observeParents: true,

                breakpoints: {
                    // 当容器宽度 <= 996px 时
                    0: {
                        // 这里定义了最小断点，覆盖所有小尺寸
                        slidesPerView: 1.1,
                        spaceBetween: 15,
                    },
                    997: {
                        // 当容器宽度 >= 997px 时恢复默认设置
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                },
            },
        }
    },
    created() {
        getTradingViewTutorial().then(response => {
            console.log("getMT5Tutorial", response)
            if (response.status && response.status == '200') {
                this.basicList = response.data.data.basic
                this.advancedList = response.data.data.advanced
            }

        }).catch(err => {
            this.basicList = []
            this.advancedList = []
        })
    },
    methods: {
        formateTime(time) {
            return moment.unix(new Date(time)).format("YYYY-MM-DD")
        },
    },
    mounted() {
        // 获取所有的QA-item元素
            var qaItems = document.querySelectorAll(".QA-item");

            // 遍历每个QA-item，为其添加点击事件监听器
            qaItems.forEach(function (item) {
                item.addEventListener("click", function () {
                    // 获取当前点击的QA-content元素
                    var content = this.querySelector(".QA-content");

                    // 如果点击的QA-content是隐藏的，则展示它；反之则隐藏
                    if (content.style.display === "none" || content.style.display === "") {
                        // 移除所有其他QA-item上的.QA-actived类，并隐藏其QA-content
                        qaItems.forEach(function (otherItem) {
                            otherItem.querySelector(".QA-content").style.display = "none";
                            otherItem.classList.remove("QA-actived");
                        });

                        // 展示当前点击的QA-content，并为当前QA-item添加.QA-actived类
                        content.style.display = "block";
                        this.classList.add("QA-actived");
                    } else {
                        // 如果已经是显示状态，则隐藏并移除.QA-actived类
                        content.style.display = "none";
                        this.classList.remove("QA-actived");
                    }
                });
            });
        

    }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");
@import url("../../assets/css/forex/forex-tool.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}
</style>